<div class="connections-chat" style="
    background-color: white;
    width: 350px;
    height: 500px;
    overflow-y: auto;
    padding: 5px;
  ">
  <div class="input-group justify-content-between m-2">
    <h2 class="m-0 text-strong" style="font-weight:bold;">MySembra Messages</h2>
    <!-- <div class="search-input d-flex align-items-center">
      <mat-icon style="position: absolute; left: 5px">search</mat-icon>
      <input matInput type="text" class="form-control" #inputSearch [placeholder]="'CHAT.SEARCH' | translate" />
    </div> -->
    <div class="input-group-append">
      <button pilot-id="connections-menu" mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
        <mat-icon>menu</mat-icon>
      </button>
      <mat-menu #menu="matMenu">
        <button mat-menu-item (click)="gotoAddressbook()">
          <span>{{ "CONNECTION.ADDRESS_BOOK" | translate }}</span>
        </button>
        <button mat-menu-item (click)="gotoNewMessage()">
          <span>{{ "CONNECTION.NEW_MSG" | translate }}</span>
        </button>
        <button mat-menu-item (click)="close()">
          <span>{{ "CONNECTION.CLOSE" | translate }}</span>
        </button>
      </mat-menu>
    </div>
  </div>
  <div class="input-group justify-content-between">
    <div class="search-input d-flex align-items-center col-11">
      <mat-form-field style="width: 100%;">
        <input matInput type="text" class="form-control" [(ngModel)]="searchValue" #inputSearch
          [placeholder]="'CHAT.SEARCH' | translate" />
        <button *ngIf="searchValue" matSuffix mat-icon-button aria-label="Clear" (click)="clearSearch()">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
    </div>
    <div class="col-1 text-center mt-3">
      <mat-icon (click)="tooltip.toggle()">info</mat-icon>
      <span #tooltip="matTooltip" matTooltipTouchGestures="off" matTooltip="Search by Username or Message Content"
        matTooltipPosition="above" matTooltipShowDelay="0">
      </span>
    </div>
  </div>
  <mat-spinner *ngIf="showLoader"></mat-spinner>
  <h2 *ngIf="connectionList.length === 0 && !this.showLoader">
    {{ "CONNECTION.NO_DATA" | translate }}
  </h2>
  <ul class="list-group list-group-full">
    <ng-container *ngFor="let data of connectionList">
      <div>
        <div class="column-1">
          <div class="blinking-green bg-primary" *ngIf="data.unread === 1"></div>
          <div class="blinking-green bg-transparent" *ngIf="data.unread === 0"></div>
        </div>
        <div class="column-2">
          <li class="list-group-item-li" (click)="gotoChat(data)">
            <div class="list-group-item"
              [class.shadeBlue]="isMessageToSpecialGroup(data) && data.alertGroup">
              <!-- [class.shadeGreen]="data.fromUserId === 'SembraCareSuccess' || data.fromUserId === 'SembraNetSupport'"> -->
              <div class="media-body d-flex justify-content-between">
                <div class="list-group-item-heading col-8">
                  <b> {{groupName(data)}} {{ showUserName(data) }}</b>
                  <b *ngIf="data.unread === 1" style="color:blue"> ({{ data.count }})</b>
                </div>
                <div style="font-size: 12px;color: rgb(91, 90, 90)" class="col-4 right-align">
                  {{ data.updateTime }}</div>
              </div>
              <div class="list-group-item-text">{{ truncateString(data,25) }}</div>
            </div>
            <!-- <div style="color: red;" *ngIf="checkYou(data.toUserId)">{{ "SEARCH_USER.YOU" | translate }}</div> -->
          </li>
        </div>
      </div>
    </ng-container>
  </ul>
</div>